<h1 mat-dialog-title class="privacyPolicyHeader">Contact Forms</h1>
<mat-dialog-content class="privacyPolicyContent">
  <div *ngFor="let contact of contacts" class="contactDialogRow">
    <div class="contactDialogTopic">
      <h3>Name:</h3>
      {{ contact.payload.doc.data().name }}
    </div>
    <div class="contactDialogTopic">
      <h3 class="contactDialogTopic">Subject:</h3>
      {{ contact.payload.doc.data().subject }}
    </div>
  </div>
</mat-dialog-content>
